import { render, staticRenderFns } from "./TSMapWidget.vue?vue&type=template&id=b2068e5c&scoped=true&"
import script from "./TSMapWidget.vue?vue&type=script&lang=js&"
export * from "./TSMapWidget.vue?vue&type=script&lang=js&"
import style0 from "./TSMapWidget.vue?vue&type=style&index=0&id=b2068e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2068e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
